// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","apps-wrapper":"Main_apps-wrapper__Vn22v","about-us-wrapper":"Main_about-us-wrapper__NnOyW","main-container":"Main_main-container__aw2s6"};